import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardTitle, CardBody, Form, FormGroup, Label,Input, Alert } from 'reactstrap';
import styled from 'styled-components';
import { doClearResetPassword, doResetPassword } from '../../actions/resetPasswordAction';

import eyeOpen from '../../images/eye-open.png';
import eyeClose from '../../images/eye-close.png';

import { isEmail, isValidPassword } from '../../helpers/regex';
import { Button, FormFeedback } from '../Forms';

const AlertSuccess= ({status_code,message, children})=>{
    return (
        status_code===200?
        <Alert className="no-border-radius" color="success">
            <h4 className="alert-heading">Well done!</h4>
            {/* <p>{`${message} Happy Shopping.`}</p> */}
            <p>Your password has been changed! Happy Shopping.</p>
            <hr/>
            <p><Link to='/' className="link link-dark">Back to Home</Link></p>
        </Alert>
        :
        children
    )
}
class PageResetPassword extends React.Component {
	constructor(props) {
        super(props);
        this.state={
            x_token:this.props.match.params.token,
            email:'',
            password:'',
            password_confirmation:'',
            _error:null,
            _submit:false,
            _isInvalidTokenError: false,
            visiblePassword: false,
            visibleConfirmPassword: false
        }
        this.toggleVisible=this.toggleVisible.bind(this);
    }

    componentDidMount(){
        this.props.load();
    }

    componentDidUpdate(prevProps){
      if(prevProps.dataReset.isSubmit && prevProps.dataReset.isSubmit !== this.props.dataReset.isSubmit){
        const { error } = this.props.dataReset;
        if(error){
          this.setState({
            _error:{
              ...error,
              errors: error.status_code === 422 && error.errors?{ ...error.errors }: {}
            },
            _isInvalidTokenError: error.status_code === 500,
            _submit:false
          })
        }else{
          this.setState({_submit:false})
        }
      }
    }

    getValue(name){
        if(this.state[name]===null||this.state[name]===undefined)
            return '';
        return this.state[name];
    }

    toggleVisible(visibleType){
      if(visibleType==='password'){
        this.setState({
          visiblePassword: !this.state.visiblePassword
        })
      } else {
        this.setState({
          visibleConfirmPassword: !this.state.visibleConfirmPassword
        })
      }
    }

	_validateForm(){
		let errors={};
        if(this.state.email==='')
            errors['email']=errors['email']!==undefined?[...errors.email,'Input your email.']:['Input your email.'];
		if(!isEmail(this.state.email))
			errors['email']=errors['email']!==undefined?[...errors.email,'Incorrect email']:['Incorrect email'];
        if(this.state.password==='')
            errors['password']=errors['password']!==undefined?[...errors.password,'Input your password.']:['Input your password.'];
        if(!isValidPassword(this.state.password))
            errors['password']=errors['password']!==undefined?[...errors.password,'Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric.']:['Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric.'];
		if(this.state.password_confirmation==='')
			errors['password_confirmation']=errors['password_confirmation']!==undefined?[...errors.password_confirmation,'Input your confirm password.']:['Input your confirm password.'];
		if(this.state.password_confirmation!==this.state.password)
			errors['password_confirmation']=errors['password_confirmation']!==undefined?[...errors.password_confirmation,'Confirm password not same with your password.']:['Confirm password not same with your password.'];
		if(Object.keys(errors).length){
			this.setState({
				_error:{errors:{...errors}, status_code:422,message:'Please fulfill your form'}
			})
		}
		return errors;
	}

    onSubmit(e){
        e.preventDefault();
        this.setState({_error:null});
        if(!Object.keys(this._validateForm()).length){
            const {email,password,password_confirmation,x_token}=this.state;
            this.setState({_submit:true},()=>this.props.submit({email,password,password_confirmation,x_token}))
        }
    }

	onChange(e) {
		this.setState({
			[e.target.name]: e.target.value
		});
    }

    hasError(name){
        if(this.state._error!==null&&this.state._error.status_code===422){
            return Object.keys(this.state._error.errors).filter(err=>err===name).length>0;
        }
        return false;
    }

  renderError(){
    if(this.state._isInvalidTokenError){
      return (
        <Alert className="no-border-radius" color="danger">
          <strong>Oh snap!</strong> Your password reset link has expired.
          Go back to the <Link title="Forgot Password" to="/forgot-password">Forgot Password</Link> page.
        </Alert>
      )
    }
    else if(this.state._error!==null){
      const { status_code, message } = this.state._error;
      switch(status_code){
        case 422:
          return (
            <Alert className="no-border-radius" color="danger">
              <strong>Oh snap!</strong> Please fullfill your form.
            </Alert>
          )
        default:
          return (
            <Alert className="no-border-radius" color="danger">
              <strong>Oh snap!</strong> {message}
            </Alert>
          )
      }
    }
    return null;
  }

  eyeClassName = () => {
    if(this.state._error!==null){
      if((this.state._error.errors.email!==undefined&&this.state._error.errors.password!==undefined&&this.state._error.errors.password_confirmation!==undefined) || (this.state._error.errors.password!==undefined && this.state._error.errors.password_confirmation!==undefined) ){
        if(this.state._error.errors.password[0].includes("8 char")){
          return "pwd-char"
        } else {
          return "with-error"
        }
      } else if((this.state._error.errors.email!==undefined && this.state._error.errors.password_confirmation!==undefined) || (this.state._error.errors.password_confirmation!==undefined)){
        return "only-confirm"
      }  else if((this.state._error.errors.email!==undefined && this.state._error.errors.password_confirmation!==undefined) || (this.state._error.errors.password!==undefined)){
        return "with-error"
      } else if(this.state._error.errors.email!==undefined){
        return null
      }
    }
  }

	render() {
    const { visiblePassword, visibleConfirmPassword } = this.state;
		return (
			<div>
				<Container className="main-container page-container reset-password">
					<Row>
            {/* <Col xs={12} size={{md: 6, offset: 3}}> */}
            <Col xs={12} className="reset-password-col">
              <Card className="no-border-radius">
                <CardBody>
                    <CardTitle className="text-center">Reset Password</CardTitle>
                </CardBody>
                <CardBody>
                  <AlertSuccess
                    status_code={this.props.dataReset.data.status_code}
                    message={this.props.dataReset.data.message}
                  >
                    <div>
                      {this.renderError()}
                      <Form onSubmit={this.onSubmit.bind(this)}>
                        <FormGroup className={classnames({'has-error':this.hasError('email')})}>
                          <Label>Email</Label>
                          {/* <Input className={classnames("form-control__input--black-lighter",{'is-invalid':this.hasError('email')})} type="text" name="email" onChange={this.onChange.bind(this)} value={this.getValue('email')} placeholder="Email*"/> */}
                          <Input className="form-control__input--black-lighter" type="text" name="email" onChange={this.onChange.bind(this)} value={this.getValue('email')} placeholder="Email*"/>
                          {/* <FormFeedback errors={this.state._error!==null?this.state._error.errors:undefined} field="email"/> */}
                          <TextError>{this.state._error!==null? (this.state._error.errors.email!==undefined?this.state._error.errors.email[0]: null) : null}</TextError>
                        </FormGroup>
                        <FormGroup className={classnames({'has-error':this.hasError('password')})}>
                          <Label>New Password</Label>
                          {/* <Input className={classnames("form-control__input--black-lighter",{'is-invalid':this.hasError('password')})} type={visiblePassword? "text" : "password"} name="password" onChange={this.onChange.bind(this)} value={this.getValue('password')} placeholder="Type New Password*"/> */}
                          <Input className="form-control__input--black-lighter" type={visiblePassword? "text" : "password"} name="password" onChange={this.onChange.bind(this)} value={this.getValue('password')} placeholder="Type New Password*"/>
                          <KickImage className={classnames("img-eye", this.eyeClassName())} src={visiblePassword? eyeOpen : eyeClose} onClick={() => this.toggleVisible('password')} alt="visible-password"/>
                          {/* <FormFeedback errors={this.state._error!==null?this.state._error.errors:undefined} field="password"/> */}
                          <TextError>{this.state._error!==null? (this.state._error.errors.password!==undefined?this.state._error.errors.password[0]: null) : null}</TextError>
                        </FormGroup>
                        <FormGroup className={classnames({'has-error':this.hasError('password_confirmation')})}>
                          <Label>Confirm Password</Label>
                          {/* <Input className={classnames("form-control__input--black-lighter",{'is-invalid':this.hasError('password_confirmation')})} type={visibleConfirmPassword? "text" : "password"} name="password_confirmation" onChange={this.onChange.bind(this)} value={this.getValue('password_confirmation')} placeholder="Type New Password*"/> */}
                          <Input className="form-control__input--black-lighter" type={visibleConfirmPassword? "text" : "password"} name="password_confirmation" onChange={this.onChange.bind(this)} value={this.getValue('password_confirmation')} placeholder="Type New Password*"/>
                          <KickImage className={classnames("img-eye confirm", {"with-error": this.state._error!==null})} src={visibleConfirmPassword? eyeOpen : eyeClose} onClick={() => this.toggleVisible('confirm')} alt="visible-password"/>
                          {/* <FormFeedback errors={this.state._error!==null?this.state._error.errors:undefined} field="password_confirmation"/> */}
                          <TextError>{this.state._error!==null? (this.state._error.errors.password_confirmation!==undefined?this.state._error.errors.password_confirmation[0]: null) : null}</TextError>
                        </FormGroup>
                        <FormGroup>
                          <Button className="btn-green bold" block size="lg" disabled={this.state._submit} buttonText="Reset"/>
                        </FormGroup>
                      </Form>
                    </div>
                  </AlertSuccess>
                </CardBody>
              </Card>
            </Col>
					</Row>
				</Container>
			</div>
		);
	}
}

const TextError = styled.span`
  font-size: .65rem;
  color: #dc3545;
`;

const mapStateToProps=state=>{
    return {
        dataReset: state.dataResetPassword,
    }
}
const mapDispatchToProps=dispatch=>{
    return {
        load: ()=>dispatch(doClearResetPassword()),
        submit: (payload)=>dispatch(doResetPassword(payload))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(PageResetPassword);